module.exports = "/images/abstract3.jpg?1f1397c314b1a4db617a9d7fef60626a";